// extracted by mini-css-extract-plugin
export default {"container":"Home_container__w+u63","title":"Home_title__L087v"};